import ReactDOM from 'react-dom';
import React, { useRef } from 'react';

interface ModalInTailwindProps {
  isOpen: boolean;
  children: JSX.Element;
  closeModal: () => void;
  dataTestId?: string;
  position?: 'right' | 'center' | 'left';
  blurBackground?: boolean;
  disableCloseOnBackdropClick?: boolean;
}

const ModalInTailwind: React.FC<ModalInTailwindProps> = ({
  isOpen,
  children,
  closeModal,
  dataTestId = 'tailwind-modal',
  position = 'center',
  blurBackground = false,
  disableCloseOnBackdropClick = false,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const handleBackgroundClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (!disableCloseOnBackdropClick && event.target === modalRef.current) {
      closeModal();
    }
  };
  const modal = document.getElementById('modal');

  const positionStyle = {
    right: 'justify-end',
    center: 'justify-center items-center',
    left: 'justify-start',
  };
  if (!modal) return null;
  return isOpen
    ? ReactDOM.createPortal(
        <div
          className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-20 overflow-hidden flex ${
            positionStyle[position]
          } cursor-default z-50 ${blurBackground && 'backdrop-blur-sm'}`}
          ref={modalRef}
          onClick={handleBackgroundClick}
          role="button"
          tabIndex={0}
          aria-hidden
          data-testid={dataTestId}
        >
          {children}
        </div>,
        modal
      )
    : null;
};

ModalInTailwind.defaultProps = {
  dataTestId: 'tailwind-modal',
  position: 'center',
  blurBackground: false,
  disableCloseOnBackdropClick: false,
};

export default ModalInTailwind;
